import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { DATA_FR } from '../data/fr';
import { LABELS } from '../data/labels';

export const ExperienceCard = ({ job, index, labels }: { job: typeof DATA_FR.experiences[0], index: number, labels: typeof LABELS['fr'] }) => (
  <motion.div
    initial={{ opacity: 0, x: -20 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ delay: index * 0.1 }}
    className="card card-hover p-6 mb-4"
  >
    <div className="flex flex-col sm:flex-row sm:items-start justify-between mb-4 gap-2">
      <div>
        <div className="flex flex-wrap items-center gap-2 mb-1">
          <h3 className="text-lg font-bold text-on-surface">{job.role}</h3>
          {job.current && <span className="badge badge-success text-xs font-medium">{labels.current}</span>}
        </div>
        <div className="text-base text-primary font-medium">{job.company}</div>
      </div>
      <div className="text-left sm:text-right">
        <div className="text-sm text-on-surface-variant font-medium">{job.period}</div>
        <div className="text-xs text-on-surface-variant/80">{job.location}</div>
      </div>
    </div>

    <p className="text-sm leading-relaxed text-on-surface-variant mb-4">{job.description}</p>

    {job.achievements && (
      <ul className="space-y-2 mb-4">
        {job.achievements.map((achievement, i) => (
          <li key={i} className="flex items-start gap-3 text-sm text-on-surface-variant">
            <CheckCircle2 className="w-5 h-5 text-tertiary mt-0.5 flex-shrink-0" />
            <span className="leading-relaxed">{achievement}</span>
          </li>
        ))}
      </ul>
    )}

    <div className="flex flex-wrap gap-2">
      {job.skills.map(skill => (
        <span key={skill} className="badge badge-default hover:bg-surface-container-highest transition-colors cursor-default">
          {skill}
        </span>
      ))}
    </div>
  </motion.div>
);
